<div class="row">
  <div class="fulfillmentLanding create-zero-dump-return-outer" (window:resize)="onresize($event)">
    <div class="zero-dump-to-report">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" routerLink="/seed-returns-soybean-dashboard">Soybean Dump</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span id="spnBreadcrum">{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="returnTop">
        <!--Ship to - Confirmation Email Section-->
        <!--[dataSource]="cppProductItemsDataSource"-->
        <div>
          <div class="row">
            <div class="col-lg-5 col-md-6 material-select withBordr">
              <ng-select name="ddlShipTo"
                         [items]="shipToAccountItems"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="shipToAccount"
                         bindLabel="accountNameCityState"
                         bindValue="accountNumber"
                         placeholder="Account:"
                         [loading]="shipToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="getShipTo($event)"
                         (clear)="getShipTo($event)">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                        <div class="mb-0 mt-2">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div>
                          Account #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="lg-ml-10">
          <button id="btnAddAccounts" class="btns margin-l-8 index-z200" mat-raised-button color="primary" (click)="addAccountsToDetailGrid(false)">Add Accounts</button>
          <button id="btnAddRelatedAccounts" mat-raised-button class="btns margin-l5 index-z200" color="primary" (click)="addAccountsToDetailGrid(true)">Add Related Accounts</button>
        </div>
      </div>
      <div class="OrderReleaseDetail">
        <div class="row">
          <div class="col-md-12 productTableOuter createZeroDumpReturnTable">
            <div class="row listing-action-items">
              <div class="col-sm-4">
                <div class="form-sec">
                  <div class="row margin-r0">
                    <div class="col-md-12 filterRow">
                      <div class="row">
                        <div class="col-md-2">
                          <mat-checkbox *ngIf="returnRequestDataSource?.filteredData?.length > 0" #AllProductCheck class="custom-checkbox select-all-check"
                                        [checked]="(isAllAccountsChecked) || returnRequestDataSource?.filteredData?.length === selectedCount" id="chkSelectAll"
                                        [style.display]="disablecheckbox ? 'none' : 'block'"
                                        [indeterminate]="checkBoxCount > 0 && !isAllAccountsChecked"
                                        (change)="enableAllCheckBoxes(!isAllAccountsChecked)"
                                        style="margin-left:11px"
                                        title="Select All Lines"></mat-checkbox>

                          <div class="product-tools-outer" *ngIf="showTabs && (!isSearchClicked && editToolKit)">
                            <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">
                              <div class="tab-bar col-md-10" style="margin-left:30px">
                                <ul>
                                  <li (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Accounts from Grid" [matTooltipPosition]="'above'">
                                    <i class="icon-ico-trash"></i>
                                  </li>
                                </ul>
                              </div>
                              <div class="tab-content">
                                <div *ngIf="tabNode==='delete'" class="delete-product">
                                  <div class="tab-content-detail">
                                    <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                                    <div class="btn-area">
                                      <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields(true)">Yes</button>
                                      <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields(false)">No</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                <div class="display-ib wAuto">
                  <mat-paginator #returnRequestPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                </div>
              </div>
            </div>
            <div class="tableContainer table-mobile" id="zerodumpReturnRequest">
              <table mat-table #returnRequestTable [dataSource]="returnRequestDataSource" matSort #returnRequestSort matSortDirection="desc" class="matTables">
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center first-checkbox"></th>
                  <td mat-cell *matCellDef="let element" class="text-left first-checkbox">
                    <mat-checkbox #SingleCheck
                                  (change)="enableCheckBoxSingle(SingleCheck._checked)"
                                  [(ngModel)]="element.isSelected"
                                  class="custom-checkbox"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Account Number</th>
                  <td mat-cell *matCellDef="let element" class="dsmNo text-left"> {{element.accountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="dsmNo text-left"> {{element.accountName}} </td>
                </ng-container>
                <ng-container matColumnDef="parentNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Parent Number</th>
                  <td mat-cell *matCellDef="let element" class="dsmNo text-left"> {{element.parentNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="parentAccountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-left">Parent Name</th>
                  <td mat-cell *matCellDef="let element" class="dsmNo text-left"> {{element.parentAccountName}} </td>
                </ng-container>
                <ng-container matColumnDef="isName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">{{impDisplayName}}</th>
                  <td mat-cell *matCellDef="let element" class="dsmNo text-left"> {{element.isName}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
              <div *ngIf="returnRequestList == undefined || returnRequestList.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="SeedFulfillBtnSec">
          <div class="row padding-l20">
            <div class="lg-ml-10">
              <button id="btnSUbmit" class="btns margin-l-8 index-z200" [disabled]="returnRequestList == undefined || returnRequestList.length == 0" mat-raised-button color="Submit" (click)="submitZeroDumpRequest()">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
